import { CommonMessage } from '@frontend/lang';
import { LuMail, LuTriangleAlert, LuX } from 'react-icons/lu';
import { useIntl } from 'react-intl';

import DeprecatedFeatureMessage from './deprecated-feature-message.component';

const ID = 'deprecated-feature-banner';

export const TELLOPORT_SUPPORT_EMAIL = 'support@telloport.com';

export interface DeprecatedFeatureBannerProps {
    onDismiss?: () => void;
}

export const DeprecatedFeatureBanner = ({ onDismiss }: DeprecatedFeatureBannerProps) => {
    const intl = useIntl();

    return (
        <div
            id={ID}
            className='bg-status-warning/20 border-status-warning mb-4 flex items-start gap-3 rounded-md border p-4'>
            <LuTriangleAlert className='text-status-warning mt-0.5 size-5 shrink-0' />
            <div className='text-foreground-default flex min-w-0 flex-1 flex-col gap-3 text-sm'>
                <DeprecatedFeatureMessage />
                <div className='mt-3'>
                    <a
                        href={`mailto:${TELLOPORT_SUPPORT_EMAIL}`}
                        className='hover:text-brand-primary inline-flex items-center gap-2 font-medium'>
                        <LuMail className='size-4 shrink-0' />
                        {TELLOPORT_SUPPORT_EMAIL}
                    </a>
                </div>
            </div>
            {onDismiss && (
                <button
                    type='button'
                    className='text-brand-muted hover:text-foreground-default shrink-0 rounded-md p-1 hover:cursor-pointer'
                    aria-label={intl.formatMessage(CommonMessage.BUTTONS.CLOSE.props)}
                    onClick={onDismiss}>
                    <LuX className='size-5' />
                </button>
            )}
        </div>
    );
};

export default DeprecatedFeatureBanner;
